import React, { Fragment, useContext, useEffect, useState } from "react";
import propTypes from "prop-types";
import { FiMinus, FiPlus, FiSave } from "react-icons/fi";

import { GridLegacy as Grid, IconButton } from "@mui/material";
import { api, Category, FTPServerType, IReportScheduleList, ReportSchedule } from "../../../../logic/api";

import Splitter from "../../../../components/splitter/Splitter";

import flex from "../../../../styles/flex";
import position from "../../../../styles/position";

import EditableGroup, { EditableGroupType } from "../../../../components/editable/EditableGroup/EditableGroup";
import EditableField, { EditableFieldTypes } from "../../../../components/editable/EditableField/EditableField";
import { IDropDownListItem } from "../../../../components/editable/EditableField/fields/DropDownField";
import { PagedDataView } from "../../../../components/lists/PagedDataView/PagedDataView";

import { SessionContext } from "../../../../utility/useSession";
import { useDate } from "../../../../utility/useDate";
import { formatCamel } from "../../../../utility/utils";
import { useReleaseManagement, ReleaseFlag } from "../../../../utility/feature-management";
import { useTranslation } from "react-i18next";

const offsetTop = 36;

const ReportScheduler: React.FunctionComponent<{
  reportId: number,
  reportTargetUuid: string | undefined
}> = (props) => {

  /*if (props.params != null && props.params.parameters.length > 0) {
      return <div style={{ padding: 20, color: "white" }}>You cannot schedule a parameter based report</div>
  }*/
  const [selectedSchedule, setSelectedSchedule] = useState<ReportSchedule | null>();
  const session = useContext(SessionContext);
  const { t } = useTranslation();
  const { localizeDate } = useDate();
  const createOrUpdateAPI = api.hooks.reportsSchedule.createOrUpdate();
  const deleteAPI = api.hooks.reportsSchedule.delete();
  const [listParams, setListParams] = useState<IReportScheduleList>({
    reportId: props.reportId,
    targetUuid: props.reportTargetUuid,
  });

  const templateFilenameReleased = useReleaseManagement(ReleaseFlag.templateReportFilename);

  const refreshScheduleList = () => {
    setListParams({
      ...listParams
    });
  };

  useEffect(() => {
    setSelectedSchedule(null);
    refreshScheduleList();

  }, [props.reportId])

  const save = () => {
    if (selectedSchedule == null) return;
    selectedSchedule.targetUuid = props.reportTargetUuid ?? selectedSchedule.targetUuid;
    createOrUpdateAPI.send(session.current.context, selectedSchedule, (result) => {
      console.log(result);
      setSelectedSchedule(result);
      refreshScheduleList();
    });
  }
  const addSchedule = () => {
    const timeOfDay = localizeDate(new Date()).toLocal().set({ hour: 17, minute: 0, second: 0, millisecond: 0 }).toISO() ?? "";

    const newSchedule: ReportSchedule = {
      reportId: props.reportId,
      name: "New Schedule",
      frequency: "Daily",
      dayOfWeek: "Monday",
      monthlyFrequency: "Last day",
      monthlyDay: 1,
      active: true,
      emailFormat: "PDF",
      ftpFormat: "CSV",
      timeOfDay: timeOfDay,
      ftpServer: "1",
      email: false,
      ftp: false,
      history: false,
      historyCutOff: 30,
      ftpDirectory: "/",
      ftpPort: 21,
      ftpHost: "",
      ftpUser: "",
      ftpPassword: "",
      ftpServerType: FTPServerType.ftps,
      ftpKey: "",
      ftpPassphrase: "",
      filename: "",
    };

    setSelectedSchedule(newSchedule);

  }
  const removeSchedule = () => {
    if (selectedSchedule == null) return;
    if (selectedSchedule.id == null) return;
    deleteAPI.send(session.current.context, {
      scheduleId: selectedSchedule.id
    }, (result) => {
      if (result != null) {
        setSelectedSchedule(null);
        refreshScheduleList();
      }
    });

  }
  const updateSchedule = (schedule: ReportSchedule) => {
    setSelectedSchedule(schedule);
  }

  const scheduleFrequency = [
    { name: t("reports.daily"), value: "Daily" },
    { name: t("reports.weekly"), value: "Weekly" },
    { name: t("reports.monthly"), value: "Monthly" }
  ]

  scheduleFrequency.unshift({ name: t("reports.hourly"), value: "Hourly" });

  return (
    <div style={{ ...position.absoluteFill, height: "auto", top: offsetTop }}>
      <div style={{ ...flex.flexRows, height: "100%" }}>
        <div style={{ ...flex.flexAuto, width: 350 }}>
          <Splitter>
            <div style={{ borderBottom: "solid 1px #ccc" }}>
              <div style={flex.flexRows}>
                <div style={flex.flexAuto}>
                  <IconButton onClick={() => addSchedule()}>
                    <FiPlus color="white" />
                  </IconButton>
                </div>
                <div style={flex.flexFill}>
                  <div style={{ paddingTop: 15, textAlign: "center", color: "white" }}>Schedules</div>
                </div>
                <div style={flex.flexAuto}>
                  <IconButton onClick={() => removeSchedule()}>
                    <FiMinus color="white"></FiMinus>
                  </IconButton>
                </div>
              </div>
            </div>
            <div style={{ overflowY: "auto", height: "100%" }}>
              <PagedDataView<IReportScheduleList, ReportSchedule>
                apiHook={api.hooks.reportsSchedule.list}
                parameters={listParams}
                renderItem={(schedule) => {
                  const isSelected = selectedSchedule != null && selectedSchedule.id == schedule.id;
                  return <div style={{ paddingTop: 10, paddingLeft: 10, paddingRight: 10 }}>
                    <div style={{ border: "solid 1px grey", color: "white", cursor: "pointer", padding: 5, borderRadius: 5 }}>
                      <div style={flex.flexRows} onClick={() => {
                        setSelectedSchedule(schedule);
                      }}>
                        <div style={flex.flexAuto}>
                          <div style={{ paddingTop: 20, paddingLeft: 10 }}>
                            <input onChange={() => {
                              setSelectedSchedule(schedule);
                            }} checked={isSelected} tabIndex={-1} type="radio" radioGroup="params" />
                          </div>
                        </div>
                        <div style={flex.flexFill}>
                          <div style={{ paddingTop: 10, paddingLeft: 20 }}>
                            {schedule.name}
                          </div>
                          <div style={{ paddingBottom: 10, paddingLeft: 20 }}>
                            {schedule.active == true ? (<b style={{ color: "green" }}>{t("reports.enabled")}</b>) : (<b style={{ color: "orange" }}>{t("reports.disabled")}</b>)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }}
              > </PagedDataView>

            </div>


          </Splitter>
        </div>
        <div style={{ ...flex.flexFill, backgroundColor: "white" }}>
          <Splitter>
            <div style={{ borderBottom: "solid 1px #ccc", borderLeft: "solid 1px #eee", borderRight: "solid 1px #333", backgroundColor: "#eee" }}>

              {
                selectedSchedule != null && (
                  <div style={flex.flexRows}>

                    <div style={flex.flexFill}>
                      <div style={{ paddingTop: 15, textAlign: "center" }}><b>{t("reports.configAutoReports")}</b></div>
                    </div>

                    <div style={flex.flexAuto}>
                      <IconButton title={t("general.save")} onClick={() => save()}>
                        <FiSave color="black" />
                      </IconButton>
                    </div>

                  </div>
                )
              }
            </div>
            <div style={{ borderLeft: "solid 1px #eee", backgroundColor: "white", height: "100%" }}>
              <div style={{ padding: 20 }}>
                {
                  selectedSchedule == null && (
                    <div>{t("reports.addSelectSchedule")}</div>
                  )
                }
                {
                  selectedSchedule != null && (
                    <div style={{ maxWidth: 800, borderRadius: 10, padding: 20 }}>
                      <EditableGroup<ReportSchedule>
                        id="scheduleDetails"
                        testId="report-schedule-group"
                        editType={EditableGroupType.alwaysEditing}
                        data={selectedSchedule}
                        onDataChanged={async (data) => {
                          updateSchedule(data);
                          return true;
                        }}
                      >

                        <div style={{ paddingLeft: 20 }}>

                          <Grid container>


                            <EditableField<ReportSchedule, string>
                              inputType={EditableFieldTypes.text}
                              label={t("reports.scheduleName")}
                              onProvide={(data) => data.name}
                              onChange={(data, value) => data.name = value}
                            />
                            <EditableField<ReportSchedule, string>
                              inputType={EditableFieldTypes.empty}
                              label={""}
                            />
                            <EditableField<ReportSchedule, boolean>
                              inputType={EditableFieldTypes.switch}
                              label={t("reports.enabled")}
                              onProvide={(data) => data.active}
                              onChange={(data, value) => data.active = value}
                            />


                          </Grid>

                        </div>

                        <div style={{ paddingLeft: 10, paddingTop: 10 }}>
                          <b>{t("reports.frequency")}</b>
                          <div style={{ paddingTop: 5, color: "gray" }}>{t("reports.configAuto")}</div>
                        </div>
                        <div style={{ paddingLeft: 20 }}>
                          <EditableField<ReportSchedule, IDropDownListItem>
                            inputType={EditableFieldTypes.terminalField}
                            label={t("reports.frequency")}
                            onProvide={(data) => {
                              return {
                                name: "",
                                value: data.frequency
                              };
                            }}
                            onChange={(data, item) => {
                              data.frequency = item.value || "";
                            }}
                            onRequestData={async () => {
                              return scheduleFrequency;
                            }}
                          />
                        </div>

                        {selectedSchedule.frequency == "Weekly" && (

                          <div style={{ paddingLeft: 20 }}>
                            <EditableField<ReportSchedule, IDropDownListItem>
                              inputType={EditableFieldTypes.terminalField}
                              label={t("reports.dayOfWeek")}
                              onProvide={(data) => {
                                return {
                                  name: "",
                                  value: data.dayOfWeek
                                };
                              }}
                              onChange={(data, item) => {
                                data.dayOfWeek = item.value || "";
                              }}
                              onRequestData={async () => {
                                return [
                                  { name: t("reports.mon"), value: "Monday" },
                                  { name: t("reports.tue"), value: "Tuesday" },
                                  { name: t("reports.wed"), value: "Wednesday" },
                                  { name: t("reports.thur"), value: "Thursday" },
                                  { name: t("reports.fri"), value: "Friday" },
                                  { name: t("reports.sat"), value: "Saturday" },
                                  { name: t("reports.sun"), value: "Sunday" }
                                ]
                              }}
                            />
                          </div>

                        )}


                        {selectedSchedule.frequency == "Monthly" && (

                          <div style={{ paddingLeft: 20 }}>
                            <EditableField<ReportSchedule, IDropDownListItem>
                              inputType={EditableFieldTypes.terminalField}
                              label={t("reports.monthFreq")}
                              onProvide={(data) => {
                                return {
                                  name: "",
                                  value: data.monthlyFrequency
                                };
                              }}
                              onChange={(data, item) => {
                                data.monthlyFrequency = item.value || "";
                              }}
                              onRequestData={async () => {
                                return [
                                  { name: t("reports.lastDay"), value: "Last Day" },
                                  { name: t("reports.specDay"), value: "Specific Day" },
                                ]
                              }}
                            />
                          </div>

                        )}
                        {(selectedSchedule.frequency == "Monthly" && selectedSchedule.monthlyFrequency == "Specific Day") && (
                          <div style={{ paddingLeft: 20 }}>
                            <EditableField<ReportSchedule, number>
                              inputType={EditableFieldTypes.number}
                              label={t("reports.day")}
                              onProvide={(data) => {
                                return data.monthlyDay;
                              }}
                              onChange={(data, item) => {
                                data.monthlyDay = item;
                              }}
                            />
                          </div>
                        )}
                        {selectedSchedule.frequency !== "Hourly" && <div style={{ paddingLeft: 20, paddingBottom: 20 }}>
                          <EditableField<ReportSchedule, string>
                            inputType={EditableFieldTypes.time}
                            label={t("reports.timeOfDay")}
                            onProvide={(data) => {
                              return data.timeOfDay;
                            }}
                            onChange={(data, item) => {
                              //Update the hours and minutes of a new date object with the selected time.
                              const d = new Date(item);
                              const timeOfDay = localizeDate(new Date()).toLocal().set({ hour: d.getHours(), minute: d.getMinutes(), second: 0, millisecond: 0 }).toUTC().toISO() ?? "";
                              //The output should be in ISO format with the timezone offset.
                              data.timeOfDay = timeOfDay;
                            }}
                          />
                        </div>}

                        <div style={{ paddingLeft: 10, paddingTop: 10 }}>
                          <b>{t("reports.emailDelivery")}</b>
                          <div style={{ paddingTop: 5, color: "gray" }}>{t("reports.emailDistList")}</div>
                        </div>
                        <div style={{ paddingLeft: 20 }}>
                          <EditableField<ReportSchedule, boolean>
                            inputType={EditableFieldTypes.switch}
                            label={t("reports.enabled")}
                            onProvide={(data) => data.email == true}
                            onChange={(data, value) => data.email = value}
                          />
                        </div>
                        {(selectedSchedule.email == true) && (
                          <Fragment>

                            <div style={{ paddingLeft: 20 }}>

                              <EditableField<ReportSchedule, IDropDownListItem>
                                inputType={EditableFieldTypes.terminalField}
                                label={t("reports.reportFormat")}
                                onProvide={(data) => {
                                  return {
                                    name: "",
                                    value: data.emailFormat
                                  };
                                }}
                                onChange={(data, item) => {
                                  data.emailFormat = item.value || "";
                                }}
                                onRequestData={async () => {
                                  return [
                                    { name: "CSV", value: "CSV" },
                                    { name: "PDF", value: "PDF" },
                                  ]
                                }}
                              />
                            </div>
                            <div style={{ paddingLeft: 20, paddingBottom: 20 }}>
                              <EditableField<ReportSchedule, Category | undefined>
                                inputType={EditableFieldTypes.distributionList}
                                label={t("reports.distList")}
                                onProvide={(data) => data.emailDistributionCategory}
                                onChange={(data, value) => data.emailDistributionCategory = value}
                              />

                            </div>
                          </Fragment>
                        )}

                        <div style={{ paddingLeft: 10, paddingTop: 10 }}>
                          <b>{t("reports.ftpDelivery")}</b>
                          <div style={{ paddingTop: 5, color: "gray" }}>{t("reports.sendFTP")}</div>
                        </div>
                        <div style={{ paddingLeft: 20 }}>
                          <EditableField<ReportSchedule, boolean>
                            inputType={EditableFieldTypes.switch}
                            label={t("reports.enabled")}
                            onProvide={(data) => data.ftp == true}
                            onChange={(data, value) => data.ftp = value}
                          />
                        </div>
                        {selectedSchedule.ftp == true && (
                          <Fragment>
                            <EditableField<ReportSchedule, IDropDownListItem>
                              inputType={EditableFieldTypes.terminalField}
                              label={t("reports.reportFormat")}
                              onProvide={(data) => {
                                return {
                                  name: "",
                                  value: data.ftpFormat
                                };
                              }}
                              onChange={(data, item) => {
                                data.ftpFormat = item.value || "";
                              }}
                              onRequestData={async () => {
                                return [
                                  { name: "CSV", value: "CSV" },
                                  { name: "PDF", value: "PDF" },
                                ]
                              }}
                            />

                            <div style={{ paddingLeft: 20 }}>
                              <EditableField<ReportSchedule, IDropDownListItem>
                                inputType={EditableFieldTypes.enumDropDownField}
                                label={t("reports.ftpType")}

                                onProvide={(data) => {
                                  return {
                                    name: "",
                                    value:
                                      data.ftpServerType == null ? "0" : data.ftpServerType.toString(),
                                  };
                                }}
                                onRequestText={(data) => {
                                  if (data.ftpServerType == null) return "";
                                  return formatCamel(FTPServerType[data.ftpServerType]);
                                }}
                                onChange={(data, value) => {
                                  data.ftpServerType = parseInt(value.value ?? "");
                                }}
                                onRequestData={async () => {
                                  const items: IDropDownListItem[] = [];
                                  for (const pt in FTPServerType) {
                                    if (isNaN(parseInt(pt))) {
                                      items.push({
                                        name: formatCamel(pt.toString()),
                                        value: FTPServerType[pt],
                                      });
                                    }
                                  }
                                  return items;
                                }}
                              />
                              <EditableField<ReportSchedule, string>
                                inputType={EditableFieldTypes.text}
                                label={t("reports.ftpHost")}
                                onProvide={(data) => data.ftpHost}
                                onChange={(data, value) => data.ftpHost = value}
                              />
                              <EditableField<ReportSchedule, number>
                                inputType={EditableFieldTypes.number}
                                label={t("reports.ftpPort")}
                                onProvide={(data) => data.ftpPort}
                                onChange={(data, value) => data.ftpPort = value}
                              />
                              <EditableField<ReportSchedule, string>
                                inputType={EditableFieldTypes.text}
                                label={t("reports.ftpDir")}
                                onProvide={(data) => data.ftpDirectory}
                                onChange={(data, value) => data.ftpDirectory = value}
                              />


                              <EditableField<ReportSchedule, string>
                                inputType={EditableFieldTypes.text}
                                label={t("reports.ftpUser")}
                                onProvide={(data) => data.ftpUser}
                                onChange={(data, value) => data.ftpUser = value}
                              />
                              <EditableField<ReportSchedule, string>
                                inputType={EditableFieldTypes.password}
                                label={t("ftpPass")}
                                onProvide={(data) => data.ftpPassword}
                                onChange={(data, value) => data.ftpPassword = value}
                              />




                              <EditableField<ReportSchedule, string>
                                inputType={EditableFieldTypes.textMultiLine}
                                label={t("reports.ftpPrivKey")}
                                onProvide={(data) => data.ftpKey}
                                onChange={(data, value) => data.ftpKey = value}
                              />
                              <EditableField<ReportSchedule, string>
                                inputType={EditableFieldTypes.password}
                                label={t("reports.ftpPassPhrase")}
                                onProvide={(data) => data.ftpPassphrase}
                                onChange={(data, value) => data.ftpPassphrase = value}
                              />



                            </div>
                          </Fragment>
                        )}
                        <div style={{ paddingLeft: 10, paddingTop: 10 }}>
                          <b>{t("reports.additionalSettings")}</b>
                          <div style={{ paddingTop: 5, color: "gray" }}>{t("reports.conDeliveryOptions")}</div>
                        </div>
                        <div style={{ paddingLeft: 20, paddingBottom: 20 }}>
                          <EditableField<ReportSchedule, boolean>
                            inputType={EditableFieldTypes.switch}
                            label={t("reports.reportNotEmpty")}
                            onProvide={(data) => data.onlySendWhenNotEmpty == true}
                            onChange={(data, value) => data.onlySendWhenNotEmpty = value}

                          />

                          {templateFilenameReleased && (
                            <EditableField<ReportSchedule, string>
                              inputType={EditableFieldTypes.text}
                              label={t("reports.filename")}
                              onProvide={(data) => data.filename || ""}
                              onChange={(data, value) => data.filename = value}
                            />
                          )}
                        </div>

                      </EditableGroup>


                    </div>
                  )
                }
              </div>

            </div>
          </Splitter>

        </div>

      </div>
    </div>
  );
}

ReportScheduler.propTypes = {
  reportId: propTypes.number.isRequired
};

export default ReportScheduler;
